import { Element } from '../../../../../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText } from '../../../../../../../../helpers/value'
import { COMPONENTS } from '../../../../../../../../routers/constants'

export const CustomTdCompanyName = ({ rowId, val }) => {
  const { name, allowRedirectLink } = val

  if (!allowRedirectLink)
    return (
      <Element>
        <TextEllipsisStaticLine
          text={formatText(name)}
          lineClamp={1}
          isI18n={false}
        />
      </Element>
    )
  return (
    <Element
      elementName="a"
      href={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${rowId}`}
      target="_blank"
      style={{ color: '#2C73E8', cursor: 'pointer' }}
    >
      <TextEllipsisStaticLine
        text={formatText(name)}
        lineClamp={1}
        isI18n={false}
      />
    </Element>
  )
}
